import { render } from "./TutorCourseReport.vue?vue&type=template&id=a996bc2c&scoped=true"
import script from "./TutorCourseReport.vue?vue&type=script&lang=js"
export * from "./TutorCourseReport.vue?vue&type=script&lang=js"

import "./TutorCourseReport.vue?vue&type=style&index=0&id=a996bc2c&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a996bc2c"]])

export default __exports__